import playerClient from "../middleware/playerClient";

export const PLAYER_PASSWORD_CHANGE_ENDPOINT = "password/change";
export const PLAYER_LOGIN_HISTORY_ENDPOINT = "login-history";

/**
 * POST api/v1/player/password/change
 * @param {{ current_password: string, new_password: string, confirm_password: string }} payload
 * Response: { success, message }. 401 INVALID_CURRENT_PASSWORD when the
 * current password is wrong; 400 when new and confirm differ.
 */
export async function changePlayerPassword(payload) {
  const response = await playerClient.post(
    PLAYER_PASSWORD_CHANGE_ENDPOINT,
    payload,
    { headers: { accept: "application/json" } }
  );
  return response.data;
}

/**
 * GET api/v1/player/login-history
 * @param {{ limit?: number, event?: string }} params
 * Response: { success, data: [{ id, event, timestamp, browser, os, device_type, ip, location, ... }] }
 */
export async function getPlayerLoginHistory(params) {
  const response = await playerClient.get(PLAYER_LOGIN_HISTORY_ENDPOINT, {
    params,
    headers: { accept: "application/json" },
  });
  return response.data;
}
